import type {CreateResourceRequest} from 'src/openapi/admin/models/CreateResourceRequest';

export const RESOURCE_EXTERNAL_ID_CONTROL = 'resource-external-id-control';
export const RESOURCE_EXTERNAL_ID_REQUIRED_ERROR = 'resource-external-id-required-error';
export const RESOURCE_EXTERNAL_ID_REQUIRED_MESSAGE = 'Resource External ID is required field';

export const RESOURCE_NAME_CONTROL = 'resource-name-control';
export const RESOURCE_NAME_REQUIRED_ERROR = 'resource-name-required-error';
export const RESOURCE_NAME_REQUIRED_MESSAGE = 'Resource Name is required field';

export const RESOURCE_DESCRIPTION_CONTROL = 'resource-description-control';
export const RESOURCE_DESCRIPTION_REQUIRED_ERROR = 'resource-description-required-error';
export const RESOURCE_DESCRIPTION_REQUIRED_MESSAGE = 'Resource Description is required field';

export const RESOURCE_METADATA_CONTROL = 'resource-metadata-control';
export const RESOURCE_METADATA_TOO_LONG_ERROR = 'resource-metadata-too-long';
export const RESOURCE_METADATA_TOO_LONG_MESSAGE = 'Metadata must not exceed 1024 characters';
export const RESOURCE_METADATA_INVALID_JSON_ERROR = 'resource-metadata-invalid-json';
export const RESOURCE_METADATA_INVALID_JSON_MESSAGE = 'Metadata must be valid JSON';

export const DEFAULT_RESOURCE: CreateResourceRequest = {
    id: '',
    name: '',
    description: '',
    namespace: '',
    metadata: undefined,
    types: undefined,
};
